<template>
  <div class="class">
    <comHead :tabIndexI="1" :imgSrc="imgSrc" />
    <div class="central-bg">
      <div class="column">
        <ul class="service-central" id="position001">
          <li
            class="serviceSection"
            name="1"
            @click="selectItem(1)"
            :class="{ newAnniu: selectedTab == 1 }"
          >
            <div class="serviceImg">
              <img
                src="../../static/imgs/classicCases/icon-1.png"
                alt=""
                class="xianshi"
              />
              <img
                src="../../static/imgs/classicCases/icon-1-2.png"
                alt=""
                class="yingcang"
              />
            </div>
            <h1 class="serviceTitle">知识产权服务</h1>
          </li>
          <li
            class="serviceSection"
            name="2"
            @click="selectItem(2)"
            :class="{ newAnniu: selectedTab == 2 }"
          >
            <div class="serviceImg">
              <img
                src="../../static/imgs/classicCases/icon-2.png"
                alt=""
                class="xianshi"
              />
              <img
                src="../../static/imgs/classicCases/icon-2-2.png"
                alt=""
                class="yingcang"
              />
            </div>
            <h1 class="serviceTitle">知识产权法律服务</h1>
          </li>
          <li
            class="serviceSection"
            name="3"
            @click="selectItem(3)"
            :class="{ newAnniu: selectedTab == 3 }"
          >
            <div class="serviceImg">
              <img
                src="../../static/imgs/classicCases/icon-3.png"
                alt=""
                class="xianshi"
              />
              <img
                src="../../static/imgs/classicCases/icon-3-2.png"
                alt=""
                class="yingcang"
              />
            </div>
            <h1 class="serviceTitle">知识产权咨询服务</h1>
          </li>
          <li
            class="serviceSection"
            name="4"
            @click="selectItem(4)"
            :class="{ newAnniu: selectedTab == 4 }"
          >
            <div class="serviceImg">
              <img
                src="../../static/imgs/classicCases/icon-4.png"
                alt=""
                class="xianshi"
              />
              <img
                src="../../static/imgs/classicCases/icon-4-2.png"
                alt=""
                class="yingcang"
              />
            </div>
            <h1 class="serviceTitle">知识产权运营服务</h1>
          </li>
        </ul>
        <ul class="service-central">
          <li
            class="serviceSection"
            name="5"
            @click="selectItem(5)"
            :class="{ newAnniu: selectedTab == 5 }"
          >
            <div class="serviceImg">
              <img
                src="../../static/imgs/classicCases/icon-5.png"
                alt=""
                class="xianshi"
              />
              <img
                src="../../static/imgs/classicCases/icon-5-2.png"
                alt=""
                class="yingcang"
              />
            </div>
            <h1 class="serviceTitle">知识产权信息化服务</h1>
          </li>
          <li
            class="serviceSection"
            name="6"
            @click="selectItem(6)"
            :class="{ newAnniu: selectedTab == 6 }"
          >
            <div class="serviceImg">
              <img
                src="../../static/imgs/classicCases/icon-6.png"
                alt=""
                class="xianshi"
              />
              <img
                src="../../static/imgs/classicCases/icon-6-2.png"
                alt=""
                class="yingcang"
              />
            </div>
            <h1 class="serviceTitle">互联网与科技应用服务</h1>
          </li>
          <li
            class="serviceSection"
            name="7"
            @click="selectItem(7)"
            :class="{ newAnniu: selectedTab == 7 }"
          >
            <div class="serviceImg">
              <img
                src="../../static/imgs/classicCases/icon-7.png"
                alt=""
                class="xianshi"
              />
              <img
                src="../../static/imgs/classicCases/icon-7-2.png"
                alt=""
                class="yingcang"
              />
            </div>
            <h1 class="serviceTitle">品牌运营服务</h1>
          </li>
          <li
            class="serviceSection"
            name="8"
            @click="selectItem(8)"
            :class="{ newAnniu: selectedTab == 8 }"
          >
            <div class="serviceImg">
              <img
                src="../../static/imgs/classicCases/icon-8.png"
                alt=""
                class="xianshi"
              />
              <img
                src="../../static/imgs/classicCases/icon-8-2.png"
                alt=""
                class="yingcang"
              />
            </div>
            <h1 class="serviceTitle">培训服务</h1>
          </li>
        </ul>
      </div>
    </div>
    <div class="detailsConcer" v-if="'1' == selectedTab">
      <div class="details">
        <div class="dignwei">
          <h1>· 知识产权代理服务</h1>
          <ul class="content">
            <li>专利</li>
            <li>商标</li>
          </ul>
          <ul class="content">
            <li>地理标志</li>
            <li>著作权</li>
          </ul>
        </div>
      </div>
      <div class="photo">
        <img src="../../static/imgs/classicCases/photo-1.jpg" alt="" />
      </div>
    </div>
    <div class="detailsConcer" v-if="'2' == selectedTab">
      <div class="details">
        <div class="dignwei">
          <h1>· 知识产权法律服务</h1>
          <ul class="content">
            <li>知识产权法律顾问</li>
            <li>知识产权尽职调查</li>
          </ul>
          <ul class="content">
            <li>知识产权维权与法律服务</li>
          </ul>
        </div>
      </div>
      <div class="photo">
        <img src="../../static/imgs/classicCases/photo-2.jpg" alt="" />
      </div>
    </div>
    <div class="detailsConcer" v-if="'3' == selectedTab">
      <div class="details">
        <div class="dignwei">
          <h1>· 知识产权咨询服务</h1>
          <ul class="content">
            <li>战略咨询与政策咨询</li>
            <li class="teshu">专利分析（专利导航、专利预警、专利侵权分析）</li>
          </ul>
          <ul class="content">
            <li>商标检测</li>
            <li>商标品牌战略规划</li>
          </ul>
          <ul class="content">
            <li>重大知识产权项目分析评议</li>
          </ul>
        </div>
      </div>
      <div class="photo">
        <img src="../../static/imgs/classicCases/photo-3.jpg" alt="" />
      </div>
    </div>
    <div class="detailsConcer" v-if="'4' == selectedTab">
      <div class="details">
        <div class="dignwei">
          <h1>· 知识产权运营服务</h1>
          <ul class="content">
            <li>知识产权价值评估</li>
            <li>知识产权运营托管</li>
          </ul>
          <ul class="content">
            <li>知识产权授权许可</li>
            <li>知识产权交易转化</li>
          </ul>
          <ul class="content">
            <li>质押融资</li>
            <li>企业知识产权管理顾问</li>
          </ul>
        </div>
      </div>
      <div class="photo">
        <img src="../../static/imgs/classicCases/photo-4.jpg" alt="" />
      </div>
    </div>
    <div class="detailsConcer" v-if="'5' == selectedTab">
      <div class="details">
        <div class="dignwei">
          <h1>· 知识产权信息化服务</h1>
          <ul class="content">
            <li>信息检索分析</li>
            <li>数据深度加工、管理</li>
          </ul>
          <ul class="content">
            <li>软件工具及平台研发</li>
            <li>产业知识产权数据库建设</li>
          </ul>
        </div>
      </div>
      <div class="photo">
        <img src="../../static/imgs/classicCases/photo-5.jpg" alt="" />
      </div>
    </div>
    <div class="detailsConcer" v-if="'6' == selectedTab">
      <div class="details">
        <div class="dignwei">
          <h1>· 互联网与科技应用服务</h1>
          <ul class="content">
            <li>品牌域名注册</li>
            <li>高端建站与系统研发</li>
          </ul>
          <ul class="content">
            <li>网络营销与运维推广</li>
            <li>信用体系建设</li>
          </ul>
        </div>
      </div>
      <div class="photo">
        <img src="../../static/imgs/classicCases/photo-6.jpg" alt="" />
      </div>
    </div>
    <div class="detailsConcer" v-if="'7' == selectedTab">
      <div class="details">
        <div class="dignwei">
          <h1>· 品牌运营服务</h1>
          <ul class="content">
            <li>品牌战略规划</li>
            <li>品牌形象设计</li>
          </ul>
          <ul class="content">
            <li>品牌宣传推广</li>
            <li>区域品牌培育</li>
          </ul>
          <ul class="content">
            <li>区域品牌运营</li>
          </ul>
        </div>
      </div>
      <div class="photo">
        <img src="../../static/imgs/classicCases/photo-7.jpg" alt="" />
      </div>
    </div>
    <div class="detailsConcer" v-if="'8' == selectedTab">
      <div class="details">
        <div class="dignwei">
          <h1>· 培训服务</h1>
          <ul class="content">
            <li>知识产权创造能力提升</li>
            <li>知识产权运用能力提升</li>
          </ul>
          <ul class="content">
            <li>知识产权保护能力提升</li>
            <li>知识产权宣传教育培训</li>
          </ul>
          <ul class="content">
            <li>知识产权服务能力提升</li>
            <li>知识产权实务人才培训</li>
          </ul>
        </div>
      </div>
      <div class="photo">
        <img src="../../static/imgs/classicCases/photo-8.jpg" alt="" />
      </div>
    </div>

    <comFooter />
  </div>
</template>

<script>
export default {
  data() {
    return {
      positionID: this.$route.query.positionID,
      tabIndex: 0,
      imgSrc: require("../../static/imgs/classicCases/content-banner.jpg"),
      selectedTab: 1,
    };
  },
  mounted() {
    if (this.positionID) {
      this.selectedTab = Number(this.positionID.substr(-1));
      document.querySelector("#position001").scrollIntoView(true);
    }
  },
  methods: {
    selectItem(i) {
      this.selectedTab = i;
      document.querySelector("#position001").scrollIntoView(true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/style/index.scss";

.class {
  background: #fff !important;

  .central-bg {
    background: url(../../static/imgs/classicCases/concer-bg.jpg) no-repeat top;
    padding: 4.5rem 0;

    .column {
      background: url(../../static/imgs/classicCases/concer.jpg) no-repeat top;
      padding: 3.25rem 4rem 1.25rem 4rem;
      max-width: 1200px;
      margin: 0 auto;

      .service-central {
        display: flex;
        text-align: center;
        padding-bottom: 3.5rem;

        .serviceSection {
          width: 25%;
          cursor: pointer;
        }
      }

      .serviceSection:hover {
        color: #0055a2;
      }
    }
    .yingcang {
      display: none;
    }
    .newAnniu h1 {
      color: #0055a2;
      font-weight: bold !important;
      margin-top: 5px;
    }
    .newAnniu .yingcang {
      display: block;
      margin: 0 auto;
    }
    .newAnniu .xianshi {
      display: none;
      margin: 0 auto;
    }
  }

  .detailsConcer {
    position: relative;

    .details {
      background: #0055a2;
      width: 50%;
      height: 400px;

      position: relative;

      .dignwei {
        position: absolute;
        right: 1rem;
        width: 60%;

        h1 {
          font-size: 2rem;
          color: #fff;
          padding: 3rem 0 1rem;
          font-weight: bold;
        }

        .content {
          display: flex;
          align-items: center;

          li {
            font-size: 1rem;
            color: #fff;
            border: 0.0625rem solid #fff;
            width: 15rem;
            height: 3.75rem;
            text-align: center;
            line-height: 3.75rem;
            margin: 1.25rem 1.25rem 0 0;
            background: rgba(255, 255, 255, 0.1);
          }

          .teshu {
            line-height: 1.3rem;
            padding-top: 0.5rem;
          }
        }
      }
    }

    .photo {
      position: absolute;
      top: 0;
      right: 0;
      width: 50%;
      overflow: hidden;

      img {
        cursor: default;
        transform: scale(1);
        transition: all 0.8s ease;
        -webkit-transition: all 0.8s ease;
        -moz-transition: all 0.8s ease;
        -ms-transition: all 0.8s ease;
        -o-transition: all 0.8s ease;
      }

      img:hover {
        transform: scale(1.2);
      }
    }
  }
}
@media screen and(max-width: 500px) {
	.class{
		.central-bg{
			.column{
				width: 100vw;
				padding: 5px;
				.service-central{
					.serviceSection{
						width: 24vw;
							.serviceImg{
								.yingcang,.xianshi{
									width: 80px;
								}
							}
					}
				}
			}
		}
		.detailsConcer{
			.details{
				    width: 100vw;
				    padding: 10px 0;
					height: auto;
					.dignwei{
						right: 0;
						width: 100vw;
						    position: relative;
						.content{
							display: block;
							li{
								width: auto;
								margin: 10px;
							}
						}
					}
			}
			.photo{
				display: none;
			}
		}
	}
}
</style>
